import { defineFeature } from "../../app/feature";
import { SystemHealthPage } from "./SystemHealthPage";

/** Operator-visible health and versions page (MER-DEP-009). Owned by the foundation lane. */
export default defineFeature({
  id: "system",
  title: "System health",
  routes: [{ path: "/system", Component: SystemHealthPage }],
  nav: { label: "System health", path: "/system", section: "Administration", order: 90 },
  permissions: ["admin.diagnostics.read"],
});
